import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import logo from '../assets/logo.png'

const NAV_LINKS = [
  { to: '/', label: 'Anasayfa' },
  { to: '/kategoriler', label: 'Kategoriler' },
  { to: '/urunlerimiz', label: 'Ürünlerimiz' },
  { to: '/hakkimizda', label: 'Hakkımızda' },
  { to: '/iletisim', label: 'İletişim' },
]

export default function Layout({ children }: { children: ReactNode }) {
  return (
    <div className="site">
      <header className="site-header">
        <div className="container site-header-inner">
          <Link to="/" className="brand">
            <img src={logo} alt="Helmach" />
          </Link>
          <nav className="site-nav">
            {NAV_LINKS.map((link) => (
              <Link key={link.to} to={link.to}>
                {link.label}
              </Link>
            ))}
            <a
              href="https://tahsilat.helmach.com.tr"
              target="_blank"
              rel="noopener noreferrer"
              className="customer-login-btn"
            >
              ÖDEME
            </a>
            <a
              href="https://hlmcrm.helmach.com.tr/login"
              target="_blank"
              rel="noopener noreferrer"
              className="customer-login-btn"
            >
              Müşteri Girişi
            </a>
          </nav>
        </div>
      </header>

      <main className="site-main">{children}</main>

      <footer className="site-footer">
        <div className="container site-footer-inner">
          <div className="site-footer-brand">
            <img src={logo} alt="Helmach" className="footer-logo" />
            <p>Otomotiv kimyasalları ve bakım ürünlerinde güvenilir çözümler.</p>
          </div>

          <div className="site-footer-col">
            <h4>Kurumsal</h4>
            <Link to="/hakkimizda">Hakkımızda</Link>
            <Link to="/kategoriler">Kategoriler</Link>
            <Link to="/urunlerimiz">Ürünlerimiz</Link>
          </div>

          <div className="site-footer-col">
            <h4>İletişim</h4>
            <Link to="/iletisim">İletişim Bilgileri</Link>
          </div>
        </div>
        <div className="site-footer-bottom">
          <div className="container">
            <p>&copy; {new Date().getFullYear()} Helmach. Tüm hakları saklıdır.</p>
          </div>
        </div>
      </footer>
    </div>
  )
}
